module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('table', [_vm._l((_vm.content), function(command) {
    return [_c('tr', [_c('td', {
      staticClass: "command"
    }, [_vm._v("\n        " + _vm._s(command.name[0]) + "\n      ")]), _vm._v(" "), (command.help) ? _c('td', {
      staticClass: "command-definition"
    }, [_vm._v(_vm._s(command.help[0]))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "command"
    }), _vm._v(" "), (command.help[1]) ? _c('td', {
      staticClass: "command-example"
    }, [_vm._v("eg. " + _vm._s(command.help[1]))]) : _c('td', {
      staticClass: "command-example"
    }, [_vm._v("eg. " + _vm._s(command.name))])])]
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You can use the following commands to get around, "), _c('br'), _vm._v("when you see "), _c('span', {
    staticClass: "faded"
  }, [_vm._v("<example>")]), _vm._v(" you don't need to put the symbols:"), _c('br'), _vm._v("\nlike so "), _c('span', {
    staticClass: "faded"
  }, [_vm._v("echo hello world")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-204d7ad6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/responses/help.vue
// module id = 288
// module chunks = 2